import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipo-resposta',
  templateUrl: './tipo-resposta.component.html',
  styleUrls: ['./tipo-resposta.component.scss']
})
export class TipoRespostaComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
